import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/i18n";
import { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const user = await login(form.email, form.password);
      toast.success(`${t("Bienvenido")}, ${user.name || user.email}`);
      const dest = location.state?.from || (user.role === "admin" || user.role === "staff" ? "/admin" : "/panel");
      navigate(dest);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-24">
      <div className="card-tech rounded-2xl p-8">
        <h1 className="text-2xl font-bold tracking-tight mb-2">{t("Iniciar sesión")}</h1>
        <p className="text-sm text-slate-400 mb-8">{t("Accede a tu panel de solicitudes CarBid.")}</p>
        <form onSubmit={submit} className="space-y-5" data-testid="login-form">
          <div>
            <Label htmlFor="email" className="text-slate-300">{t("Correo electrónico")}</Label>
            <Input id="email" data-testid="login-email" type="email" required value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="mt-1.5 bg-[#0B0F1A] border-white/15 focus:ring-2 focus:ring-blue-500" placeholder="tu@correo.com" />
          </div>
          <div>
            <Label htmlFor="password" className="text-slate-300">{t("Contraseña")}</Label>
            <Input id="password" data-testid="login-password" type="password" required value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="mt-1.5 bg-[#0B0F1A] border-white/15 focus:ring-2 focus:ring-blue-500" placeholder="••••••••" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2">{error}</p>}
          <Button data-testid="login-submit" type="submit" disabled={loading}
            className="w-full bg-[#2563EB] hover:bg-[#1D4ED8] text-white rounded-full h-11">
            {loading ? t("Entrando...") : t("Entrar")}
          </Button>
        </form>
        <p className="text-sm text-slate-400 mt-6 text-center">
          {t("¿No tienes cuenta?")} <Link to="/registro" className="text-[#2563EB] hover:text-blue-400 transition-colors">{t("Regístrate")}</Link>
        </p>
      </div>
    </div>
  );
}
